import 帐篷1 from "./帐篷1"
import 帐篷2 from "./帐篷2"
import 帐篷3 from "./帐篷3"

const list = [ 帐篷1, 帐篷2, 帐篷3 ];
export default list